var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:['list-group',{'list-group-flush':_vm.flush}]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }